import Button from "../../components/Button";
import BackgroundImage from "../../assets/icons/pback.png";
import { useState } from "react";
import Div100vh from "react-div-100vh";
import { DotLottiePlayer } from "@dotlottie/react-player";
import ErrorImage from "../../assets/icons/error.lottie";
import NoInternet from "../../assets/icons/nonet.lottie";

const ErrorFallback = ({ error }) => {
  const [loading, setLoading] = useState(false);

  return error?.message?.includes("Loading chunk") ? (
    <Div100vh
      className={
        "flex flex-col flex-1 items-center justify-center relative p-10 h-screen mx-auto bg-white text-error font-bold text-center"
      }
    >
      <div
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          filter: "brightness(170%)",
        }}
        className="opacity-5 absolute left-0 top-0 h-full w-full"
      ></div>

      <div className="max-w-lg mx-auto text-center z-50">
        <DotLottiePlayer
          src={NoInternet}
          loop
          autoplay
          className={"w-full p-5 max-w-xs mx-auto"}
        />
        <div>
          متاسفانه ارتباط شما با سرور/اینترنت قطع است.در صورت تداوم خطا با
          پشتیبانی تماس بگیرید.
          <p className="my-3 ltr">:تلفن تماس پشتیبانی</p>
          <a
            href="tel:02188616116"
            className="font-semibold text-brand text-header -mb-1 underline underline-offset-3 decoration-brand"
          >
            021-88616116
          </a>
        </div>
        <div className={"flex flex-row w-full mt-6"}>
          <Button
            loading={loading}
            disabled={loading}
            className={"mt-2 w-full md:max-w-48 md:mx-auto"}
            onClick={() => {
              setLoading(true);
              window.location.reload();
            }}
          >
            تلاش مجدد
          </Button>
        </div>
      </div>
    </Div100vh>
  ) : (
    <Div100vh
      className={
        "flex flex-col flex-1 items-center justify-center relative p-10 h-screen mx-auto bg-white text-error font-bold text-center"
      }
    >
      <div
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          filter: "brightness(170%)",
        }}
        className="opacity-5 absolute left-0 top-0 h-full w-full"
      ></div>

      <div className="max-w-lg mx-auto text-center z-50">
        <DotLottiePlayer
          src={ErrorImage}
          loop
          autoplay
          speed={1}
          className={"w-full p-5 max-w-xs mx-auto"}
        />
        <div>
          متاسفانه خطایی رخ داده است. لطفا پنل را مجدد راه اندازی کنید و در صورت
          تداوم خطا با پشتیبانی تماس بگیرید.
          <p className="my-3 ltr">:تلفن تماس پشتیبانی</p>
          <a
            href="tel:02188616116"
            className="font-semibold text-brand text-header -mb-1 underline underline-offset-3 decoration-brand"
          >
            021-88616116
          </a>
        </div>
        <div className={"flex flex-row w-full mt-6"}>
          <Button
            loading={loading}
            disabled={loading}
            className={"mt-2 w-full md:max-w-48 md:mx-auto"}
            onClick={() => {
              setLoading(true);
              window.location.reload();
            }}
          >
            راه اندازی مجدد
          </Button>
        </div>
      </div>
    </Div100vh>
  );
};

export default ErrorFallback;
